(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["citydoctor-contents-cards"] && !Shopify.designMode) return;
  try {
    (() => {
    const bindContents = () => {
      document.querySelectorAll('[data-cdj-contents]').forEach(root => {
        if (root.dataset.contentsBound) return;
        root.dataset.contentsBound = 'true';
        const service = root.closest('[data-cdj]');
        if (!service) return;
        const panels = [...root.querySelectorAll('[data-contents-variant]')];

        const previewNote = root.querySelector('[data-contents-preview-note]');
        const heldNote = root.querySelector('[data-contents-held-note]');
        const names = panel => [...panel.querySelectorAll('.cdj-contents-cards__name')].map(n => n.textContent.trim()).join('|');
        const sameNames = panels.length > 0 && panels.every(panel => names(panel) === names(panels[0]));
        const sync = () => {
          const inputs = [...service.querySelectorAll('[data-choice-group] input')];
          const selected = inputs.find(input => input.checked);
          const needsChoice = root.dataset.contentsMultiple === 'true' && inputs.length > 0;
          const selectedId = selected?.dataset.shopifyVariant || (!needsChoice ? root.dataset.contentsDefaultVariant : null);
          const match = panels.find(panel => panel.dataset.contentsVariant === selectedId) || null;
          // Before a strength is chosen: names and what they are for, no amounts, and only when every strength lists the same names.
          const preview = (!selected && needsChoice && sameNames) ? panels[0] : null;
          // A strength whose list is not confirmed: no list, one honest line.
          const held = Boolean(selected && !match);
          panels.forEach(panel => { panel.hidden = panel !== (match || preview); panel.toggleAttribute('data-contents-preview', panel === preview); });
          if (previewNote) previewNote.hidden = !preview;
          if (heldNote) heldNote.hidden = !held;
          const hide = !(match || preview || held);
          if (root.hidden !== hide) root.hidden = hide;
        };
        service.addEventListener('change', event => {
          if (event.target.matches('[data-choice-group] input')) sync();
        });
        new MutationObserver(sync).observe(service, {subtree: true, attributes: true, attributeFilter: ['data-shopify-variant', 'checked']});
        sync();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindContents, {once: true});
    else bindContents();
    document.addEventListener('shopify:section:load', bindContents);
  })();
  } catch(e) { console.error(e); }
})();

})();
